import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Link } from 'react-router-dom';
import { Search, Layers, Map } from 'lucide-react';

export default function RegionsIndexPage() {
  const navigate = useNavigate();

  // Redirect to providers page if necessary
  useEffect(() => {
    // You can implement conditional redirects here if needed
  }, [navigate]);

  return (
    <div className="container mx-auto py-6">
      <h1 className="text-2xl font-bold mb-6">Regions Management</h1>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <Card>
          <CardHeader className="pb-2">
            <CardTitle>Provider Regions</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground mb-4">
              Browse and manage regions by provider
            </p>
            <Button asChild className="w-full">
              <Link to="/providers">
                <Map className="mr-2 h-4 w-4" />
                View Provider Regions
              </Link>
            </Button>
          </CardContent>
        </Card>
        
        <Card>
          <CardHeader className="pb-2">
            <CardTitle>Search by Zip Code</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground mb-4">
              Find regions that serve specific zip codes
            </p>
            <Button asChild variant="outline" className="w-full">
              <Link to="/regions/search">
                <Search className="mr-2 h-4 w-4" />
                Search by Zip Code
              </Link>
            </Button>
          </CardContent>
        </Card>
        
        <Card>
          <CardHeader className="pb-2">
            <CardTitle>Region Activity</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground mb-4">
              View region activity and version information
            </p>
            <Button asChild variant="secondary" className="w-full">
              <Link to="/regions/activity">
                <Layers className="mr-2 h-4 w-4" />
                View Activity
              </Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
} 